import React from 'react';
import ManageUsersList from '../components/manage-users/ManageUsersList';
import Landing from '../components/Landing';
import ManageCategories from '../components/manage-categories/ManageCategories';
import ManageRoles from '../components/manage-roles/ManageRoles';
import Wholesaler from '../components/wholesaler/Wholesaler';
import ApiError from '../components/error/ApiError';


const LazyComponents = {
  Landing: () => (<Landing/>),
  Wholesaler: () => (<Wholesaler/>),
  ManageUsersList: () => (<ManageUsersList/>),
  ManageRoles: () => (<ManageRoles/>),
  ManageCategories: () => (<ManageCategories/>),
  SessionExpired: () => (<ApiError/>)
};

export default LazyComponents;
